module.exports = __webpack_public_path__ + "img/trait_default2.edad5fb8.png";